<section class="spacer-pt-space spacer-pb-space lg:bg-black solution-bottom-space">
    <div class="container">
        <div class="intro-text text-center">
            <h2 class="heading-primary-8xl text-black lg:text-white hidden lg:block">Our Solutions</h2>
            <h2 class="heading-primary-8xl text-black lg:text-white lg:hidden">Our <u>Solutions</u></h2>
            <div class="editor-content text-black lg:text-white lg:max-w-[560px] lg:mx-auto"
                [innerHTML]="data.description"></div>
        </div>
        <div class="hidden lg:block">
            <div class="tab-section">
                @for(item of data.items; track $index){
                <button class="tab-button flex-col" type="button" title="{{item.title}}"
                    [class.active]="selectedTab == $index"
                    (click)="selectedTab = $index">{{item.title}} @if(item.titleSubtext){<span>{{item.titleSubtext}}</span>}</button>
                }
            </div>
        </div>
        <div class="accordion tabAccordion" data-accordion-section="section" data-accordion-multiple="false">
            @for(item of data.items; track $index){
            <div class="accordion-items" data-accordion-item="item"
                [ngClass]="{'tabShow': selectedTab == $index , 'active' : $index == 0}">
                <div class="accordion-heading" data-accordion-heading="heading">
                    <p>{{item.title}} @if(item.titleSubtext){<span>{{item.titleSubtext}}</span>}</p>
                </div>
                <div class="accordion-content" data-accordion-content="content">
                    <div class="row flex-col-reverse lg:flex-row px-6 pb-5 lg:px-0 lg:pb-0">
                        <div class="col-lg-6">
                            <div class="intro-text !mb-3 lg:!mb-[43px] lg:pr-8">
                                <div [innerHTML]="item?.subtitle"
                                    class="editor-content text-white mb-4 text-14 font-inter-medium tab-editor"></div>
                                <h3 class="heading-primary-7xl text-white mb-5 md:mb-6 hidden lg:block">
                                    {{item.title}}
                                </h3>
                                <div class="editor-content text-white  lg:min-h-[100px] h-full relative  tabContentLeft"
                                    [innerHTML]="item.description"></div>
                            </div>
                            <a type="button" title="Explore Now"
                                class="button button-orange button-arrow button-rounded"
                                (click)="handler_redirect(item.redirection)" routerLink="/solutions">Explore
                                Now</a>
                        </div>
                        <div class="col-lg-6">
                            <img [ngSrc]="assetsCDNUrl+item.imageUrl" class="h-auto mb-5 lg:mb-0 rounded-[5px]"
                                alt="Wealth Management" width="586" height="287" loading="lazy" />
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</section>